import { connect } from 'react-redux';
import Modal from 'comp/modals/task';
import * as selectors from 'selectors';
import { cache } from 'utils';

const mapToProps = state => ({
  status: state.fetch.group_update_tasks || cache.empty_obj,
  selected_group: state.ui.selected_group,
  task: state.group[state.ui.selected_group].tasks[state.ui.selected_task],
  edit_mode: true,
  upload_list: selectors.getFilesForUploadList({ g_id: 'task', u_id: state.ui.selected_group })
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/EditTask.js